const resources = {
    showMore: 'Show more',
    rougeBadge: 'ROUGE'
};

export default function getResource(label) {
    return resources[label];
}
